<template>
  <div class="dc-login is-create-account">
    <h2 class="dc-login__title">
      {{$t('views.createAccount.pageTitleEdit')}}
    </h2>
    <el-card class="dc-login__card" :body-style="cardBodyStyle">
      <div class="dc-login__card-inner">
        <el-form ref="form" class="dc-login__form"
                 :hide-required-asterisk="true"
                 :model="model" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="firstName" :label="$t('views.createAccount.firstNameLabel')">
                <el-input v-model="model.firstName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="lastName" :label="$t('views.createAccount.lastNameLabel')">
                <el-input v-model="model.lastName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="emailAddress" :label="$t('views.createAccount.emailAddressLabel')">
                <el-input disabled v-model="model.emailAddress"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="phoneNumber" :label="$t('views.createAccount.phoneNumberLabel')">
                <el-input v-model="model.phoneNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="dc-login__card-footer clearfix">
        <el-button type="primary" class="float-right dc-login__button"
                   @click="onContinueBtnClick">
          {{$t('views.createAccount.submitBtn')}}
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { mapActions } from  'vuex';
  import Services from '../../services';
  import loading from '../../common/mixins/loading';

  export default {
    name: 'register',
    mixins: [
      loading
    ],
    data () {
      const _this = this;
      return {
        cardBodyStyle: {
          padding: 0
        },
        model: {
          firstName: '',
          lastName: '',
          emailAddress: '',
          phoneNumber: '',
        },
        rules: {
          firstName: [
            { required: true, message: _this.$t('views.createAccount.firstNameEmpty'), trigger: 'blur' }
          ],
          lastName: [
            { required: true, message: _this.$t('views.createAccount.lastNameEmpty'), trigger: 'blur' }
          ],
          phoneNumber: [
            { required: true, message: _this.$t('views.createAccount.phoneNumberEmpty'), trigger: 'blur' }
          ],
        }
      }
    },
    mounted () {
        this.showLoading();
        Services.getAllUserinfo({}).then(res => {
            this.model = res.info
            this.closeLoading()
        })
    },
    methods: {
      ...mapActions([
        'updateUserName'
      ]),
      _submit () {
          let _data = {
            first_name: this.model.firstName,
            last_name: this.model.lastName,
            phone: this.model.phoneNumber,
          }
          Services.postUserEdit(_data).then(res=>{
              if (res) {this.updateUserName(res.name)}
              let message = this.$t('iews.createAccount.editAccountSuccess')
              this.$message({
                  message: message,
                  type: 'success'
              })
              setTimeout(() => {
                this.$router.push({path: '/account'})
              }, 1000);
          })
      },
      onContinueBtnClick () {
        const $form = this.$refs['form'];
        if ($form) {
          $form.validate().then(() => {
            this._submit();
          });
        }
      }
    }
  };
</script>
